/*
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { DateTime } from "luxon";

export function formatDateTimeISO(dateTimeISO: string): string {
	return DateTime.fromISO(dateTimeISO).toLocaleString(DateTime.DATETIME_SHORT);
}
